import ProductItemRegular from "./ProductItemRegular";
import ProductItemMarket from "./ProductItemMarket";

const ProductItem = (props) => {
    // מחליט איזה קומפוננט להציג לפי סוג התפריט
    return props.isMarket ? 
        <ProductItemMarket {...props} /> : 
        <ProductItemRegular {...props} />;
}

export default ProductItem;